// [ai] /browse — the folders card in page mode (the same card, no modal backdrop); #folder=<path> (the sidebar tree) reveals a folder.
import { useEffect } from "react";
import { useLocation } from "react-router";
import { usePlayerCtl } from "../player/context";
export function BrowsePage() {
  const p = usePlayerCtl(); const { hash } = useLocation(); const folder = /^#folder=(.+)$/.exec(hash)?.[1];
  useEffect(() => { void p.browserOpen(true, p.item?.id ?? null, { page: true, folder: folder ? decodeURIComponent(folder) : null }); return () => p.browserPageLeft(); }, [p, folder]);
  return <div className="at-page at-browse-page" />;
}
